import { render } from "./WellnessContent.vue?vue&type=template&id=fcb85a24&scoped=true"
import script from "./WellnessContent.vue?vue&type=script&lang=js"
export * from "./WellnessContent.vue?vue&type=script&lang=js"

import "./WellnessContent.vue?vue&type=style&index=0&id=fcb85a24&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb85a24"]])

export default __exports__